// Device detection utilities
export const isIos = () => {
  if (typeof window === "undefined" || !window.navigator) return false;
  return /iPhone|iPad|iPod/.test(window.navigator.userAgent);
};

export const isAndroid = () => {
  if (typeof window === "undefined" || !window.navigator) return false;
  return /Android/.test(window.navigator.userAgent);
};

export const isTablet = () => {
  if (typeof window === "undefined" || !window.navigator) return false;
  const userAgent = window.navigator.userAgent;
  const isIpadOS =
    /Macintosh/.test(userAgent) &&
    window.navigator &&
    window.navigator.maxTouchPoints > 0;

  return /iPad|Android(?!.*Mobile)/.test(userAgent) || isIpadOS;
};

export const detectPlatform = () => {
  if (isIos() || (isTablet() && !isAndroid())) {
    return "ios";
  }
  if (isAndroid()) {
    return "android";
  }
  return null;
};
